import { render } from "./MSight.vue?vue&type=template&id=b2129a44&scoped=true"
import script from "./MSight.vue?vue&type=script&lang=js"
export * from "./MSight.vue?vue&type=script&lang=js"

import "./MSight.vue?vue&type=style&index=0&id=b2129a44&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2129a44"]])

export default __exports__